

export const Footer=()=>{
    
    return(
        <div className="footer">
            <div className="__container">
                <div className="footer_row">
                    <div className="footer_about">
                        <strong>AOD New York</strong>
                        <p>2250 Lexington Avenue</p>
                        <p>New York, NY 10035 - <a href="#">info@domain.com</a></p>
                    </div>
                    <div className="footer_contacts">
                        <img src={require('../../static/twitter-icon.png')}/>
                        <img src={require('../../static/facebook-icon.png')}/>
                        <img src={require('../../static/pintrest-icon.png')}/>
                    </div>
                    <div className="footer_copyright">
                        <p>designed by</p>
                        <img src={require('../../static/yebo-icon.png')}/>
                    </div>
                </div>
            </div>
        </div>
    )
}